import React from 'react';
import { useQuery } from '@apollo/client/react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  GetRecurringInvoicesForContractDocument,
  GetRecurringInvoicesForContractQuery,
  GetRecurringInvoicesForContractQueryVariables,
  GetInvoicesForContractQuery,
  GetInvoicesForContractQueryVariables,
  GetInvoicesForContractDocument,
} from '../../../generated/graphql';
import { InvoiceList } from './invoice-list';
import { RecurringInvoiceList } from './recurring-invoice-list';

interface RelatedInvoicesSectionProps {
  contractId: string;
  disabled?: boolean;
  tabValue: string;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`invoices-tabpanel-${index}`}
      aria-labelledby={`invoices-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

export function RelatedInvoicesSection({ contractId, disabled, tabValue, onTabChange }: RelatedInvoicesSectionProps) {
  const { data: recurringData, refetch: refetchRecurring } = useQuery<
    GetRecurringInvoicesForContractQuery,
    GetRecurringInvoicesForContractQueryVariables
  >(GetRecurringInvoicesForContractDocument, {
    variables: { contractId },
  });

  const { data, refetch: refetchInvoices } = useQuery<
    GetInvoicesForContractQuery,
    GetInvoicesForContractQueryVariables
  >(GetInvoicesForContractDocument, {
    variables: { contractId },
  });

  const invoices = data?.getInvoicesForContract || [];
  const recurringInvoices = recurringData?.getRecurringInvoicesForContract || [];

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={onTabChange} aria-label="invoice tabs">
          <Tab label="Faktúry" id="reldocs-tab-0" aria-controls="reldocs-tabpanel-0" value="invoices" />
          <Tab label="Pravidelné faktúry" id="reldocs-tab-1" aria-controls="reldocs-tabpanel-1" value="recurring" />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={'invoices'}>
        <InvoiceList
          contractId={contractId}
          invoices={invoices}
          onRefresh={() => refetchInvoices()}
          disabled={disabled}
          pageSize={10}
        />
      </TabPanel>
      <TabPanel value={tabValue} index={'recurring'}>
        {recurringData && (
          <RecurringInvoiceList
            contractId={contractId}
            recurringInvoices={recurringInvoices}
            onRefresh={() => refetchRecurring()}
            disabled={disabled}
          />
        )}
      </TabPanel>
    </Box>
  );
}
